export type LearningHintSide = 'top' | 'right' | 'bottom' | 'left';
export type LearningHintAlign = 'start' | 'center' | 'end';

export type LearningHint = {
    /** CSS selector of the element the hint belongs to; see `learningAnchor`. */
    element: string;
    title: string;
    description: string;
    side?: LearningHintSide;
    align?: LearningHintAlign;
};

/** The selector for an element stamped with `data-learning={key}`. */
export function learningAnchor(key: string) {
    return `[data-learning="${key}"]`;
}
